 /**
* Returns numerical hourly price for paid courses
*
* @param {number} priceInCents
* @param {number} hoursPerSession
* @param {number} sessionCount
*/

export default (priceInCents, hoursPerSession, sessionCount) => {
  const priceByHour = ((priceInCents/100) / (hoursPerSession * sessionCount));
  return Math.round(priceByHour);
};
